import styled from 'styled-components/macro';

const StyledInternationalAddress = styled.div`
    width: 100%;
`;

export default StyledInternationalAddress;
